var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 9,
    viewBox: "0 0 50 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 42,
    height: 3,
    fill: "#EB4A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5 9C43.0147 9 41 6.98528 41 4.5C41 2.01472 43.0147 0 45.5 0C47.9853 0 50 2.01472 50 4.5C50 6.98528 47.9853 9 45.5 9ZM45.5 6C46.3284 6 47 5.32843 47 4.5C47 3.67157 46.3284 3 45.5 3C44.6716 3 44 3.67157 44 4.5C44 5.32843 44.6716 6 45.5 6Z",
    fill: "#EB4A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection2Line);
export default __webpack_public_path__ + "static/media/section2_line.df551c3690e024e354a97a6625fb5e67.svg";
export { ForwardRef as ReactComponent };